import Axios from "../../api/Axios";
const BASE_URL = "Reports/";
export const Endpoint = {
    InvoiceDataExcel: "InvoiceDataExcel",
    GetQtrData: "GetQtrData",
};
export const createAPIEndpointInvoiceExcel = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};